import { useEffect, useState } from 'react';

/**
 * Single source of truth for "is this a small screen" across the app.
 * Cuts over at Tailwind's `md` breakpoint (768px) so sidebar, dialogs,
 * tables and forms all agree on the boundary.
 *
 * Drop-in replacement for the old MUI-backed hook — same `{ isMobile }`
 * shape, no MUI dependency.
 */
const MOBILE_QUERY = '(max-width: 767.98px)';

function getMatch(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }
  return window.matchMedia(MOBILE_QUERY).matches;
}

export interface MobileLayout {
  isMobile: boolean;
}

export function useMobileLayout(): MobileLayout {
  const [isMobile, setIsMobile] = useState<boolean>(getMatch);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return;
    }
    const mql = window.matchMedia(MOBILE_QUERY);
    const handler = (event: MediaQueryListEvent) => setIsMobile(event.matches);
    setIsMobile(mql.matches);
    mql.addEventListener('change', handler);
    return () => {
      mql.removeEventListener('change', handler);
    };
  }, []);

  return { isMobile };
}

export default useMobileLayout;
